export enum FormFieldConditionOption {
  Filled = 0,
  Empty = 1,
  Equals = 2,
  NotEquals = 3
}
